import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './keycloak-theme.magic.css.js';
import script from './keycloak-theme.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('magic-ui-text',{staticClass:"title",attrs:{"part":"title","tag":"h3","content":_vm.title}}),_vm._v(" "),(_vm.description)?_c('magic-ui-text',{staticClass:"description",attrs:{"part":"description","tag":"h3","content":_vm.description}}):_vm._e(),_vm._v(" "),(_vm.notification)?_c('div',{staticClass:"notification",attrs:{"part":"notification"}},[_c('magic-ui-text',{attrs:{"tag":"p","content":_vm.notification}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAutoSubmitting),expression:"!isAutoSubmitting"}],staticClass:"keycloak-theme-content",attrs:{"part":"keycloak-theme-content"},on:{"notification":_vm.getNotification}},[(_vm.kcContext.pageId === 'login.ftl')?_c('magic-corex-keycloak-login',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 't_and_c.ftl')?_c('magic-corex-keycloak-tnc',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 'error.ftl')?_c('magic-corex-keycloak-error',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 'info.ftl')?_c('magic-corex-keycloak-info',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 'login-update-password.ftl')?_c('magic-corex-keycloak-update-password',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 'login-reset-password.ftl')?_c('magic-corex-keycloak-reset-password',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 'login-page-expired.ftl')?_c('magic-corex-keycloak-login-expired',{domProps:{"kcContext":_vm.kcContext}}):(_vm.kcContext.pageId === 'configure-sms-otp.ftl')?_c('magic-corex-keycloak-configure-otp',{ref:"configureOtp",domProps:{"kcContext":_vm.kcContext},on:{"auto-submitting":_vm.onAutoSubmitting}}):(_vm.kcContext.pageId === 'login-sms.ftl')?_c('magic-corex-keycloak-login-sms',{domProps:{"kcContext":_vm.kcContext}}):_c('magic-corex-keycloak-info',{domProps:{"kcContext":_vm.kcContext}})],1),_vm._v(" "),(_vm.isAutoSubmitting)?_c('div',{staticClass:"keycloak-theme-loader",attrs:{"part":"keycloak-theme-loader"}},[_c('magic-ui-loader')],1):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-0de476cc_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-0de476cc";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
